/**
 * Turkish and Hungarian attach the plural/adjective suffix to the decade year with vowel
 * harmony decided by the last word spoken aloud: tr 1990 "doksan" → 1990'lar, 1980 "seksen" →
 * 1980'ler; hu 1980 "nyolcvan" → 1980-as évek, 1990 "kilencven" → 1990-es évek.
 * The catalogs carry one form ("{decade}'ler", "{decade}-as évek"); this picks the right vowel.
 */
/** Tens words with back vowels: tr on, otuz, kırk, altmış, doksan. */
const TR_BACK_TENS = new Set([1, 3, 4, 6, 9]);
/** Tens words with back vowels: hu húsz, harminc, hatvan, nyolcvan. */
const HU_BACK_TENS = new Set([2, 3, 6, 8]);

export function harmonizeDecadeLabel(locale: string, label: string, decade: number): string {
  const tens = Math.floor(decade / 10) % 10;
  const hundreds = Math.floor(decade / 100) % 10;
  if (locale === "tr") {
    // A round hundred or thousand ends in "yüz" / "bin", both front-vowel.
    const back = tens !== 0 && TR_BACK_TENS.has(tens);
    return label.replace(/'l[ae]r(?!\p{L})/u, back ? "'lar" : "'ler");
  }
  if (locale === "hu") {
    // A round hundred ends in "száz" (back); a round thousand in "ezer" (front).
    const back = tens !== 0 ? HU_BACK_TENS.has(tens) : hundreds !== 0;
    return label.replace(/-[ae]s(?= évek)/u, back ? "-as" : "-es");
  }
  return label;
}
